module.exports = __webpack_public_path__ + "static/media/MiniBuddha.80c8f6de.png";